import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { PointsBlock, useConfig, useTranslations } from "@jti/ui";
import { useCartMiniContext } from "../../../../contexts/CartMiniContext";
import styles from "./CartMiniPointsBlock.module.scss";
export const CartMiniPointsBlock = ({ totalPoints, isActive = false, pending = false, }) => {
    const { __ } = useTranslations();
    const config = useConfig();
    const { isDarkTheme } = useCartMiniContext();
    if (totalPoints === 0 || pending || !isActive) {
        return null;
    }
    const wrapperClasses = classNames(styles.pointsBlockWrapper, {
        [styles.dark]: isDarkTheme,
    });
    return (_jsx("div", { className: wrapperClasses, children: _jsx(PointsBlock, { hasLogo: true, knowMoreUrl: config.LOYALTY_KNOW_MORE_URL, urlText: __("cart.ploom_club.pointsBlock.link"), points: totalPoints, pointsLabel: __("cart.ploom_club.points"), text: __("cart.ploom_club.pointsBlock.message", [totalPoints]) }) }));
};
//# sourceMappingURL=CartMiniPointsBlock.js.map